module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_library.js
// module id = 172
// module chunks = 16